var map = {
	"./image1.png": 17763,
	"./image10.png": 13387,
	"./image11.png": 66082,
	"./image12.png": 80089,
	"./image2.png": 80904,
	"./image3.png": 74769,
	"./image4.png": 91678,
	"./image5.png": 60519,
	"./image6.png": 41516,
	"./image7.png": 93781,
	"./image8.png": 6578,
	"./image9.png": 37755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48381;